import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-156" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-157" data-mp="3fze45yusr5w7">
        <h2 className="text-center font-heading text-[1.15rem] font-bold uppercase text-navy sm:text-[1.9rem]" data-id="element-158" data-mp="3fy2z7vpm7s3i">
          Professionals using the system
        </h2>
        <div className="mt-2 space-y-2" data-id="element-159" data-mp="36ziphk218srf">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 bg-ivory p-2.5 shadow-sm" data-id="element-160" data-mp="32060otrlpbm7">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-161" data-mp="2x1l0guccmrxr">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-162" data-mp="2s3t9c2jj39um" />)}
              </div>
              <blockquote className="mt-1 text-[0.8rem] leading-[1.35] text-ink sm:text-[0.95rem]" data-id="element-163" data-mp="q8irj9lkt6n4">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-1 font-body text-[0.68rem] font-extrabold uppercase tracking-wide text-navy sm:text-xs" data-id="element-164" data-mp="m5swuah3fokz">
                {t.name}
                <span className="block font-body text-[0.66rem] font-medium normal-case tracking-normal text-muted" data-id="element-165" data-mp="c6llttxu0611">
                  {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}